import React from 'react';
import './QuoteText.scss';

export const QuoteText = ({ node }) => {
    const quoteText = node.field_content_text?.value;
    const speaker = node.field_quote_speaker;

    if (!quoteText || !speaker) {
        return (
            <p className="component-error">
                ERROR: This component must have both a quote and a speaker.
            </p>
        );
    }

    return (
        <div
            className={`themed-container quote-content ${node.field_theme?.toLowerCase()}`}
        >
            <figure>
                <blockquote
                    className="typestack-title-1"
                    dangerouslySetInnerHTML={{ __html: quoteText }}
                ></blockquote>
                <figcaption className="author typestack-title-6">
                    - {speaker}
                </figcaption>
            </figure>
        </div>
    );
};
